module.exports = __webpack_public_path__ + "static/media/is-four-IHC.00f488d6.png";